import * as React from 'react';
import { searchDataSource } from 'data/SearchDataSource';
import { observer } from 'mobx-react';
import { computed } from 'mobx';

/**
 * used by:
 * Notification
 */
@observer
export class NotificationLink extends React.Component<{notification:any, user:any, handleSetCurrentPage:(page:string)=>void}> {
  
	@computed
	get notificationBody(){
		let content = this.props.notification.title;
		content = content.replace(/{{firstName}}/g, this.props.user.firstName);
		content = content.replace(/{{firstName}}/g, this.props.user.lastName);
		content = content.replace(/{{email}}/g, this.props.user.email);
		return {
			__html: content
		}
	}

	@computed
	get buttonTitle() {
		return this.props.notification.buttonTitle ? this.props.notification.buttonTitle : "GO";
	}

	handleClick = () => {
		searchDataSource.setSearchText(this.props.notification.searchText);
		this.props.handleSetCurrentPage(this.props.notification.navPageName);
	}

	render(){
		let button:any;
		if(this.props.notification.action){
			button = <a className="go_button" href={this.props.notification.action} target="_blank">{this.buttonTitle}</a>;
		} else if(this.props.notification.navPageName) {
			button = <a className="go_button" onClick={this.handleClick}>{this.buttonTitle}</a>;
		}
		return (
			<div>
				<div className="alertBody" dangerouslySetInnerHTML={this.notificationBody}></div>
				{button}
			</div>
		);
	}
}
